<script>
export default {
  name:"AccountSourceSelect",
  data(){
    return {
      accountSourceOptions: [
        { label: '组内提供微信', val: 'pwg' },
        { label: '自己寻找', val: 'fys' }
      ],
    }
  }
}

</script>

<template>
  <div>
    <el-select v-bind='$attrs' v-on='$listeners' :clearable="true">
      <el-option :label="item.label" :value="item.val"
                 v-for="(item,idx) in accountSourceOptions" :key="idx">
        {{ item.label }}
      </el-option>
    </el-select>
  </div>
</template>

<style scoped>

</style>
